const state = {
  countries: [],
  allowedCountries: [],
  allowedPhonePrefixes: []
}

const getters = {
  countries: state => state.countries,
  allowedCountries: state => state.allowedCountries,
  allowedPhonePrefixes: state => state.allowedPhonePrefixes
}

const mutations = {
  SET_COUNTRIES (state, countries) {
    state.countries = countries
  },

  SET_ALLOWED_LISTS (state, settings) {
    state.allowedCountries = settings.allowed_list || []
    state.allowedPhonePrefixes = settings.allowed_telephones_list || []
  }
}

const actions = {
  setCountries ({ state, commit }, countries) {
    commit('SET_COUNTRIES', countries)
  },

  setAllowedLists ({ state, commit }, settings) {
    commit('SET_ALLOWED_LISTS', settings)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
